import React, { CSSProperties } from "react";

import { Anchor } from "@atlassiansox/bxp-content-framework";

import { colorContrastCSS, fontSizes } from "../../styles";

// Use $transientProps to keep props local to styled-components
// Docs: https://styled-components.com/docs/api#transient-props
export type GenericShareButtonProps = {
    $buttonColor: string;
    $colorOverride?: string;
    $block?: boolean;
    style?: CSSProperties;
    [key: string]: unknown;
};

export const GenericShareButton = ({
    $buttonColor,
    $colorOverride,
    $block = false,
    style,
    ...props
}: GenericShareButtonProps) => {
    const color = $colorOverride
        ? $colorOverride
        : colorContrastCSS($buttonColor);
    const buttonStyle: CSSProperties = {
        backgroundColor: $buttonColor,
        borderRadius: "0.3rem",
        color: color,
        fontSize: fontSizes.sm,
        display: $block ? "block" : "inline-block",
        minWidth: $block ? undefined : "150px",
        padding: "0.75rem",
        textAlign: "left",
        textDecoration: "none",
        ...style
    };
    return <Anchor style={buttonStyle} {...props} />;
};

type InnerShareButtonProps = React.HTMLAttributes<HTMLDivElement> & {
    style?: CSSProperties;
};

export const InnerShareButton = ({
    style,
    children,
    ...props
}: InnerShareButtonProps) => (
    <div
        style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            ...style
        }}
        {...props}
    >
        {React.Children.map(children, (child, index) =>
            index === 0 ? (
                child
            ) : (
                <span style={{ marginLeft: "0.5rem" }}>{child}</span>
            )
        )}
    </div>
);
